module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"cancel":"取消","create":"註冊我的資訊","update":"修改我的資訊","edit":"修改","apply":"套用","reset":"取消選取"}}')
  delete Component.options._Ctor
}
